import type { WmtsTile } from "@/cache/PVSTileService/TileGetters/WMTSTileGetter/WMTSTile";
import { ColorMap } from "@mm/api.meteomatics.com";

export function hasId(obj: any): obj is { id: number } {
  return obj && typeof obj.id === "number";
}
export function isColorMap(value: unknown): value is ColorMap {
  return typeof value === "string" && Object.prototype.hasOwnProperty.call(ColorMap, value);
}

export function isPlaceholderTile(t: WmtsTile): t is WmtsTile & { isPlaceholder: true; placeholderUntil: number } {
  return t.isPlaceholder === true && typeof t.placeholderUntil === "number";
}
